var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPmailicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.346,
    height: 12.439,
    viewBox: "0 0 16.346 12.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29846",
    "data-name": "Grupo 29846",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48365",
    "data-name": "Caminho 48365",
    d: "M14.35,57.75H2a2,2,0,0,0-2,2v8.442a2,2,0,0,0,2,2H14.347a2,2,0,0,0,2-2V59.752A2,2,0,0,0,14.35,57.75Zm1.086,10.441a1.087,1.087,0,0,1-1.086,1.086H2A1.087,1.087,0,0,1,.913,68.191V59.752A1.087,1.087,0,0,1,2,58.667H14.347a1.087,1.087,0,0,1,1.086,1.086v8.438Z",
    transform: "translate(0 -57.75)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48366",
    "data-name": "Caminho 48366",
    d: "M64.175,113.287l4-3.585a.457.457,0,1,0-.612-.68l-5.513,4.948-1.076-.961s-.007-.007-.007-.01a.674.674,0,0,0-.074-.064l-4.376-3.916a.458.458,0,1,0-.609.683l4.045,3.615-4.028,3.771a.458.458,0,0,0-.02.646.467.467,0,0,0,.335.145.458.458,0,0,0,.311-.122l4.089-3.825,1.109.991a.455.455,0,0,0,.609,0L63.5,113.9l4.065,3.862a.458.458,0,0,0,.646-.017.458.458,0,0,0-.017-.646Z",
    transform: "translate(-53.867 -107.172)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPmailicon);
export default __webpack_public_path__ + "static/media/LPmailicon.2dd95a72bdf20cfff7eaaf66733a1a0a.svg";
export { ForwardRef as ReactComponent };